import "client-only";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";
function useManufacturerList(params) {
  return useSWR(
    {
      path: `/api/v1/manufacturers`,
      method: "GET",
      params,
    },
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useManufacturerList;
